/**
 * @file src/api/purchaseRefund.api.js
 * @description Vendor refunds (cash back from vendor). /purchases/refunds
 */

import { apiClient } from "lib/axios";

const normalizeRefund = (refund) => {
  if (!refund) return refund;
  return {
    ...refund,
    id: refund.id || refund._id,
    vendorId:
      refund.vendorId?._id || refund.vendorId?.id || refund.vendorId || "",
    vendorName: refund.vendorName || refund.vendorId?.name || "—",
  };
};

const normalizeListResponse = (data) => {
  const refunds = data?.refunds || data?.data?.refunds || data?.data || [];
  return {
    ...data,
    refunds: Array.isArray(refunds) ? refunds.map(normalizeRefund) : [],
  };
};

const normalizeItemResponse = (data) => {
  const refund = data?.refund || data?.data?.refund || data?.data || data;
  return { ...data, refund: normalizeRefund(refund) };
};

const buildCleanPayload = (payload) => ({
  vendorId: payload.vendorId,
  creditNoteId: payload.creditNoteId || null,
  refundDate: payload.refundDate,
  amount: payload.amount,
  paymentMode: payload.paymentMode,
  branchId: payload.branchId || null,
  refundTo: payload.refundTo || "",
  reference: payload.reference || "",
  reason: payload.reason || "",
});

export const getPurchaseRefunds = async (params = {}) => {
  const { data } = await apiClient.get("/purchases/refunds", { params });
  return normalizeListResponse(data);
};

export const getPurchaseRefundById = async (id) => {
  const { data } = await apiClient.get(`/purchases/refunds/${id}`);
  return normalizeItemResponse(data);
};

export const createPurchaseRefund = async (payload) => {
  const { data } = await apiClient.post(
    "/purchases/refunds",
    buildCleanPayload(payload),
  );
  return normalizeItemResponse(data);
};

export const voidPurchaseRefund = async (id, body = {}) => {
  const { data } = await apiClient.post(`/purchases/refunds/${id}/void`, body);
  return normalizeItemResponse(data);
};
